// Offline fallback only — real projects come from /api/projects (dashboard-managed).
const API = process.env.REACT_APP_BACKEND_URL;

export const PROJECTS = [];

export async function fetchProjects() {
  const res = await fetch(`${API}/api/projects`);
  if (!res.ok) throw new Error("projects fetch failed");
  return res.json();
}

export async function fetchProject(slug) {
  const res = await fetch(`${API}/api/projects/${slug}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error("project fetch failed");
  return res.json();
}
